// ─── Scroll-position save / restore ──────────────────────────────────────────
// Saves the full collection grid HTML + scroll position to sessionStorage
// every time the user navigates to a product page. On back-navigation from a
// product page the saved state is restored instantly, without a round-trip.

(function () {
  'use strict';

  // Key is URL-specific so filters, sorting and pages are all handled correctly.
  function stateKey() {
    return 'avc_state' + location.pathname + location.search;
  }

  function saveState() {
    var el = document.getElementById('collection-ajax');
    if (!el) return;
    try {
      sessionStorage.setItem(stateKey(), JSON.stringify({
        scrollY: window.scrollY || window.pageYOffset || 0,
        html: el.innerHTML
      }));
    } catch (e) {}
  }

  // Returns true when this page load is a browser back/forward navigation.
  // document.referrer NON è affidabile per questo: sulla navigazione
  // "indietro" i browser in genere non lo aggiornano per riflettere la
  // pagina da cui si torna — resta quello del primo caricamento. Per
  // questo il ripristino non scattava quasi mai tornando da un prodotto.
  function isBackNavigation() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav) return nav.type === 'back_forward';
    } catch (e) {}
    // Fallback per browser più vecchi senza la Navigation Timing API v2.
    return !!(performance.navigation && performance.navigation.type === 2);
  }

  function tryRestoreState() {
    if (!isBackNavigation()) return;
    try {
      var stored = JSON.parse(sessionStorage.getItem(stateKey()));
      if (!stored || !stored.html) return;
      var el = document.getElementById('collection-ajax');
      if (!el) return;
      el.innerHTML = stored.html;
      // Two rAF passes ensure the browser has measured the restored layout
      // before we move the scroll position.
      var scrollY = stored.scrollY;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.scrollTo(0, scrollY);
          // Script di terze parti (es. widget di pagamento rateale) possono
          // inserire contenuto nelle card prodotto DOPO questo momento, anche
          // in card sopra alla posizione corrente, spostando involontariamente
          // la pagina verso il basso. Per qualche secondo ripristiniamo la
          // posizione corretta ogni volta che la griglia cambia altezza.
          keepScrollStableFor(scrollY, 2500);
        });
      });
    } catch (e) {}
  }

  // Si ferma da sola dopo `durationMs`, o subito se il cliente inizia a
  // scorrere manualmente — non deve mai contrastare uno scroll intenzionale.
  function keepScrollStableFor(targetScrollY, durationMs) {
    var grid = document.getElementById('collection-ajax');
    if (!grid || typeof ResizeObserver === 'undefined') return;

    var active = true;
    var observer = new ResizeObserver(function () {
      if (active) window.scrollTo(0, targetScrollY);
    });

    function stop() {
      active = false;
      observer.disconnect();
    }

    observer.observe(grid);
    window.addEventListener('wheel', stop, { passive: true, once: true });
    window.addEventListener('touchstart', stop, { passive: true, once: true });
    setTimeout(stop, durationMs);
  }

  // Save state right as the page is being navigated away from, not on click.
  // Saving on click would JSON.stringify + write potentially hundreds of KB
  // of grid HTML (after several "Load More" clicks) synchronously on the
  // click's critical path, adding perceptible latency before the browser
  // even starts navigating. pagehide fires during the navigation itself, off
  // that path, and covers back/forward/address-bar navigation too — not just
  // clicks on product links.
  window.addEventListener('pagehide', saveState);

  // Expose for InfiniteScroll to call right after appending products, so a
  // "Load More" click is captured even if the tab is closed immediately after.
  window._avcSaveState = saveState;

  // Restore state as soon as the DOM is ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryRestoreState);
  } else {
    tryRestoreState();
  }
}());

// ─── InfiniteScroll custom element (Load More button) ─────────────────────────
// • Fetches the next page of products and appends them to the existing grid.
// • Pre-fetches the NEXT page in the background via requestIdleCallback so
//   clicking "Mostra altro" is instant on fast connections.
// • Saves collection state to sessionStorage after each load so back-nav works.

if (!customElements.get('infinite-scroll')) {
  customElements.define('infinite-scroll', class InfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.nextUrl    = this.dataset.nextUrl || null;
      this.isFetching = false;
      this._prefetched = null; // pre-fetched HTML for nextUrl

      this.button.addEventListener('click', this._fetchNextPage.bind(this));

      if (this.dataset.triggerType === 'infinite') {
        this._initIntersectionObserver();
      }

      // Pre-fetch the next page silently in the background.
      this._schedulePrefetch();
    }

    _initIntersectionObserver() {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) this._fetchNextPage();
        }.bind(this));
      }.bind(this), { threshold: 0.5 }).observe(this);
    }

    _schedulePrefetch() {
      if (!this.nextUrl) return;
      var self = this;

      var run = function () {
        if (!self.nextUrl || self._prefetched) return;
        var doFetch = function () {
          if (!self.nextUrl || self._prefetched) return;
          fetch(self.nextUrl)
            .then(function (r) { return r.text(); })
            .then(function (html) { self._prefetched = html; })
            .catch(function () {});
        };
        if ('requestIdleCallback' in window) {
          requestIdleCallback(doFetch, { timeout: 6000 });
        } else {
          setTimeout(doFetch, 2000);
        }
      };

      // Wait for the current page's own 50 product images to finish loading
      // before spending bandwidth on the next page — otherwise this fetch
      // competes with them for the same connection pool and can stall or
      // delay images still in view.
      if (document.readyState === 'complete') {
        run();
      } else {
        window.addEventListener('load', run, { once: true });
      }
    }

    _fetchNextPage() {
      if (this.isFetching || !this.nextUrl) return;
      this.isFetching = true;
      this.button.classList.add('loading');

      var self = this;

      var apply = function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid       = doc.getElementById('product-grid-ajax');
          var newPagination = doc.getElementById('pagination-ajax');
          var curGrid       = document.getElementById('product-grid-ajax');
          var curPagination = document.getElementById('pagination-ajax');

          if (newGrid && curGrid) {
            // Strip any promotional banners injected by the theme into new pages.
            newGrid.querySelectorAll('.card--banner').forEach(function (el) {
              el.parentNode.removeChild(el);
            });
            curGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
          }

          // Replacing pagination HTML creates a new <infinite-scroll> element
          // that auto-upgrades with connectedCallback (new nextUrl, new prefetch).
          if (newPagination && curPagination) {
            curPagination.innerHTML = newPagination.innerHTML;
          }

          // Save full state so back-navigation can restore position + all products.
          if (window._avcSaveState) window._avcSaveState();

        } catch (err) {
          console.error('[InfiniteScroll] apply error:', err);
        } finally {
          // self still refers to the old (now detached) element — that's fine.
          self.isFetching = false;
          self.button.classList.remove('loading');
        }
      };

      if (self._prefetched) {
        // Instant path: use the pre-fetched response.
        var html = self._prefetched;
        self._prefetched = null;
        apply(html);
      } else {
        fetch(self.nextUrl)
          .then(function (r) { return r.text(); })
          .then(apply)
          .catch(function (err) {
            console.error('[InfiniteScroll] fetch error:', err);
            self.isFetching = false;
            self.button.classList.remove('loading');
          });
      }
    }
  });
}
